import { ANIMATE_ACTIONS } from '../Actions/animateActions';

const ANIMATE_INITIAL_STATE = {
    switchAnimateHeroStatsDisplayPlayerImgDamage: false,
};

const animateReducer = (state = ANIMATE_INITIAL_STATE, action) => {
    switch (action.type) {
        case ANIMATE_ACTIONS.SWITCH_HERO_STATS_DISPLAY_PLAYER_IMG_DAMAGE: {
            
            let nextState = {
                ...state,
                switchAnimateHeroStatsDisplayPlayerImgDamage: !state.switchAnimateHeroStatsDisplayPlayerImgDamage
            }
            return nextState;
        }

    }
    return state;
}

export default animateReducer;